module.exports = __webpack_public_path__ + "static/media/shaff1102.7da8b3bd.jpg";